import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CMSContentService } from '../essentials/cms/content/cms-content.service';
import { Observable } from 'rxjs';

export interface ArticleData {
  date: string;
  category: string;
  subcategory?: string;
  content?: string;
  banner: string;
  slug: string;
  documents?: any[];
  tags?: any[];
  video?: { title: string; urlIframe: string };
  description: string;
  title: string;
  id: string;
}

export enum DetailHighlight {
  NEWS = 'noticias',
  PUBLISHING = 'publicacoes'
}

@Component({
  selector: 'fcp-detail-highlight',
  templateUrl: './detail-highlight.component.html',
  styleUrls: ['./detail-highlight.component.scss']
})
export class DetailHighlightComponent {
  public articles: Observable<Array<ArticleData>>;
  public linkToBack: string;

  constructor(
    private route: ActivatedRoute,
    private cmsContentService: CMSContentService
  ) {
    window?.scrollTo(0, 0);
    this.linkToBack = DetailHighlight.NEWS;
    const category = this.getParamSnapshot('category');
    if (this.isNews()) {
      const slug = this.getParamSnapshot('slug');
      const slugToFilter = category + '/' + slug;
      this.linkToBack = DetailHighlight.NEWS;
      this.articles = this.cmsContentService.getNewHighlight(slugToFilter);
    } else if (this.isPublishing()) {
      const subcategory = this.getParamSnapshot('subcategory');
      const title = this.getParamSnapshot('title');
      const slugToFilter = category + '/' + subcategory + '/' + title;
      this.linkToBack = DetailHighlight.PUBLISHING;
      this.articles = this.cmsContentService.getPublishingHighlight(
        slugToFilter
      );
    }
  }

  private getParamSnapshot(id: string): string {
    return this.route.snapshot.paramMap.get(id);
  }

  private isNews(): boolean {
    return this.route.toString().includes('noticias');
  }

  private isPublishing(): boolean {
    return this.route.toString().includes('publicacoes');
  }
}
